import script from "./MessageView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageView.vue?vue&type=script&setup=true&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=73930688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73930688"]])

export default __exports__